import { randomBytes } from './encoding';

/**
 * 복구 키 (결정 D3): 160-bit 난수를 Crockford Base32 32자로 표시, 4자씩 8그룹.
 * 사람이 옮겨 적기 쉽도록 혼동 문자(I, L, O, U)를 쓰지 않는다.
 */
const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
export const RECOVERY_KEY_BYTES = 20;

export function generateRecoveryKey(): { bytes: Uint8Array; display: string } {
  const bytes = randomBytes(RECOVERY_KEY_BYTES);
  return { bytes, display: formatRecoveryKey(bytes) };
}

export function formatRecoveryKey(bytes: Uint8Array): string {
  let bits = 0;
  let value = 0;
  let out = '';
  for (const b of bytes) {
    value = (value << 8) | b;
    bits += 8;
    while (bits >= 5) {
      out += ALPHABET[(value >>> (bits - 5)) & 31];
      bits -= 5;
    }
  }
  if (bits > 0) out += ALPHABET[(value << (5 - bits)) & 31];
  return out.match(/.{1,4}/g)!.join('-');
}

export function parseRecoveryKey(input: string): Uint8Array {
  const clean = input.toUpperCase().replace(/[\s-]/g, '').replace(/[IL]/g, '1').replace(/O/g, '0');
  if (clean.length !== 32) throw new Error('복구 키는 32자여야 합니다');
  const out = new Uint8Array(RECOVERY_KEY_BYTES);
  let bits = 0;
  let value = 0;
  let i = 0;
  for (const ch of clean) {
    const v = ALPHABET.indexOf(ch);
    if (v < 0) throw new Error('복구 키에 허용되지 않는 문자가 있습니다');
    value = (value << 5) | v;
    bits += 5;
    if (bits >= 8) {
      out[i++] = (value >>> (bits - 8)) & 0xff;
      bits -= 8;
    }
  }
  return out;
}
